






































import Vue from 'vue'
import SquareButton from '@/components/atoms/SquareButton.vue'

export default Vue.extend({
  name: 'TheDrawer',
  components: {
    SquareButton
  },
  props: {
    isDrawerShown: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isLoggedIn(): boolean {
      return this.$state.auth.isLoggedIn
    }
  },
  methods: {
    onClose() {
      this.$emit('onClose')
    },
    handleSignUpClick() {
      this.$router.push('/registration')
      this.onClose()
    },
    handleLoginClick() {
      this.$router.push('/signin')
      this.onClose()
    },
    handleLogoutClick() {
      this.$emit('onClose')
      this.$store.dispatch('auth/logout')
    }
  }
})
